import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState(['activitiesStore', 'locationsStore', 'vesselsStore', 'voyageReportsStore', 'bulksStore', 'tanksStore', 'clientsStore']),
    ...mapGetters({
      getActiveSite: 'userStore/getActiveSite',
      getVesselsWithTanks: 'vesselsStore/getVesselsWithTanks',
    }),
    activeSiteId() {
      const site = this.getActiveSite;
      if (!site) {
        return null;
      }
      return site.id;
    },
    locations() {
      return this.locationsStore ? this.locationsStore.locations : null;
    },
    activities() {
      return this.activitiesStore ? this.activitiesStore.activities : null;
    },
    vessels() {
      return this.vesselsStore ? this.vesselsStore.vessels : null;
    },
    vesselTanks() {
      return this.tanksStore ? this.tanksStore.vesselTanks : null;
    },
    bulks() {
      return this.bulksStore ? this.bulksStore.bulks : null;
    },
    clients() {
      return this.clientsStore ? this.clientsStore.clients : null;
    },
    locationsTableData() {
      if (this.locations) {
        return this.locations.map((x) => (
          {
            id: x.id,
            name: x.name,
            type: x.type,
            latitude: x.latitude,
            longitude: x.longitude,
            isActive: x.isActive,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    activitiesTableData() {
      if (this.activities) {
        return this.activities.map((x) => (
          {
            id: x.id,
            activityName: x.activityName,
            code: x.code,
            activityType: x.activityType,
            activityInfo: x.activityInfo,
            locationType: x.locationType,
            isCommentRequired: x.isCommentRequired,
            isBulkTransactionActivity: x.isBulkTransactionActivity,
            isSailingActivity: x.isSailingActivity,
            isShiftInPortActivity: x.isShiftInPortActivity,
            isCargoHandlingActivity: x.isCargoHandlingActivity,
            isActive: x.isActive,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    vesselsTableData() {
      if (this.vessels) {
        return this.vessels.map((x) => (
          {
            id: x.id,
            name: x.name,
            isActive: x.isActive,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    bulksForTableData() {
      if (this.bulks) {
        return this.bulks.map((x) => (
          {
            id: x.id,
            bulkName: x.bulkName,
            bulkType: x.bulkType,
            isActive: x.isActive,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    tanksTableData() {
      if (this.vesselTanks) {
        return this.vesselTanks.map((x) => (
          {
            ...x,
            vesselId: x.vessel.id,
            maxCapacityString: `${x.maxCapacity} ${x.qtyUom}`,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    clientsTableData() {
      if (this.clients) {
        return this.clients.map((x) => (
          {
            ...x,
            isActiveDisplayValue: x.isActive ? 'Yes' : 'No',
          }
        ));
      }
      return [];
    },
    locationTypes() {
      return this.locationsStore ? this.locationsStore.locationTypes : null;
    },
    bulkTypes() {
      return this.bulksStore ? this.bulksStore.bulkTypes : null;
    },
  },
  data() {
    return {
      locationHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Latitude', value: 'latitude' },
        { text: 'Longitude', value: 'longitude' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
      activitiesHeaders: [
        { text: 'Name', value: 'activityName' },
        { text: 'Code', value: 'code' },
        { text: 'Type', value: 'activityType' },
        { text: 'Info', value: 'activityInfo' },
        { text: 'LocationType', value: 'locationType' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
      vesselsHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
      bulksHeaders: [
        { text: 'Bulk Name', value: 'bulkName' },
        { text: 'Bulk Type', value: 'bulkType' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
      tankHeaders: [
        { text: 'Vessel Name', value: 'vesselName' },
        { text: 'Tank Name', value: 'tankName' },
        { text: 'Tank Type', value: 'tankBulkType' },
        { text: 'Bulk', value: 'bulkName' },
        { text: 'Maximum Capacity (m3/T)', value: 'maxCapacityString' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
      clientsHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Active', value: 'isActiveDisplayValue' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  methods: {
    // LOCATIONS
    submitLocation(location, edit) {
      if (!edit) {
        this.createLocation(location);
      } else {
        this.editLocation(location);
      }
    },
    createLocation(location) {
      const newLocation = {
        siteId: this.activeSiteId,
        name: location.name,
        locationType: location.type,
        latitude: location.latitude,
        longitude: location.longitude,
      };
      this.$store.dispatch('locationsStore/createVesselLocation', newLocation)
        .then((res) => {
          this.onSuccess('Location Created', res);
          this.$refs.locationsAdmin.resetForm();
        })
        .catch((err) => { this.onError('Failed to Create Location', err); });
    },
    editLocation(editedLocation) {
      const locationUpdate = {
        id: editedLocation.id,
        name: editedLocation.name,
        locationType: editedLocation.type,
        latitude: editedLocation.latitude,
        longitude: editedLocation.longitude,
        isActive: editedLocation.isActive,
      };

      this.$store.dispatch('locationsStore/updateLocation', locationUpdate)
        .then((res) => {
          this.onSuccess('Location Updated', res);
          this.$refs.locationsAdmin.closeFormDialog();
        })
        .catch((err) => {
          this.onError('Failed to Update Location', err);
        });
    },
    deleteLocation(id) {
      this.$store.dispatch('locationsStore/deleteLocation', id)
        .then((res) => {
          this.onSuccess('Location Deleted', res);
        })
        .catch((err) => { this.onError('Failed to Delete Location', err); });
    },
    // ACTIVITIES
    submitActivity(activity, edit) {
      if (!edit) {
        this.createActivity(activity);
      } else {
        this.editActivity(activity);
      }
    },
    createActivity(activity) {
      const newActivity = {
        siteId: this.activeSiteId,
        activityName: activity.activityName,
        code: activity.code,
        activityType: activity.activityType,
        activityInfo: activity.activityInfo,
        locationType: activity.locationType,
        isCommentRequired: activity.isCommentRequired,
        isBulkTransactionActivity: activity.isBulkTransactionActivity,
        isSailingActivity: activity.isSailingActivity,
        isShiftInPortActivity: activity.isShiftInPortActivity,
        isCargoHandlingActivity: activity.isCargoHandlingActivity,
      };
      this.$store.dispatch('activitiesStore/createActivity', newActivity)
        .then((res) => {
          this.onSuccess('Activity Created', res);
          this.$refs.activitiesAdmin.resetForm();
        })
        .catch((err) => {
          this.onError('Failed to Create Activity', err);
        });
    },
    editActivity(editedActivity) {
      const activityUpdate = {
        id: editedActivity.id,
        activityName: editedActivity.activityName,
        code: editedActivity.code,
        activityType: editedActivity.activityType,
        activityInfo: editedActivity.activityInfo,
        locationType: editedActivity.locationType,
        isCommentRequired: editedActivity.isCommentRequired,
        isBulkTransactionActivity: editedActivity.isBulkTransactionActivity,
        isSailingActivity: editedActivity.isSailingActivity,
        isShiftInPortActivity: editedActivity.isShiftInPortActivity,
        isActive: editedActivity.isActive,
        isCargoHandlingActivity: editedActivity.isCargoHandlingActivity,
      };
      this.$store.dispatch('activitiesStore/updateActivity', activityUpdate)
        .then((res) => {
          this.onSuccess('Activity Updated', res);
          this.$refs.activitiesAdmin.closeFormDialog();
        })
        .catch((err) => {
          this.onError('Failed to Update Activity', err);
        });
    },
    deleteActivity(id) {
      this.$store.dispatch('activitiesStore/deleteActivity', id)
        .then((res) => {
          this.onSuccess('Activity Deleted', res);
        })
        .catch((err) => { this.onError('Failed to Delete Activity', err); });
    },
    // VESSELS
    submitVessel(vessel, edit) {
      if (!edit) {
        this.createVessel(vessel);
      } else {
        this.editVessel(vessel);
      }
    },
    createVessel(vessel) {
      const newVessel = {
        siteId: this.activeSiteId,
        name: vessel.name,
      };
      this.$store.dispatch('vesselsStore/createVessel', newVessel)
        .then((res) => {
          this.onSuccess('Vessel Created', res);
          this.$refs.vesselsAdmin.resetForm();
        })
        .catch((err) => { this.onError('Failed to Create Vessel', err); });
    },
    editVessel(editedVessel) {
      const vesselUpdate = {
        id: editedVessel.id,
        name: editedVessel.name,
        isActive: editedVessel.isActive,
      };

      this.$store.dispatch('vesselsStore/updateVessel', vesselUpdate)
        .then((res) => {
          this.onSuccess('Vessel Updated', res);
          this.$refs.vesselsAdmin.closeFormDialog();
        })
        .catch((err) => {
          this.onError('Failed to Update Vessel', err);
        });
    },
    deleteVessel(id) {
      this.$store.dispatch('vesselsStore/deleteVessel', id)
        .then((res) => {
          this.onSuccess('Vessel Deleted', res);
        })
        .catch((err) => { this.onError('Failed to Delete Vessel', err); });
    },
    // BULKS
    submitBulk(bulk, edit) {
      if (!edit) {
        this.createBulk(bulk);
      } else {
        this.editBulk(bulk);
      }
    },
    createBulk(bulk) {
      const newBulk = {
        siteId: this.activeSiteId,
        bulkName: bulk.bulkName,
        bulkType: bulk.bulkType,
      };
      this.$store.dispatch('bulksStore/createBulk', newBulk)
        .then((res) => {
          this.onSuccess('Bulk Created', res);
          this.$refs.bulksAdmin.resetForm();
        }).catch((err) => this.onError('Failed to Create Bulk', err));
    },
    editBulk(editedBulk) {
      const bulkUpdate = {
        id: editedBulk.id,
        bulkName: editedBulk.bulkName,
        bulkType: editedBulk.bulkType,
        isActive: editedBulk.isActive,
      };

      this.$store.dispatch('bulksStore/updateBulk', bulkUpdate)
        .then((res) => {
          this.onSuccess('Bulk Updated', res);
          this.$refs.bulksAdmin.closeFormDialog();
        }).catch((err) => this.onError('Failed to Update Bulk', err));
    },
    deleteBulk(id) {
      this.$store.dispatch('bulksStore/deleteBulk', id)
        .then((res) => {
          this.onSuccess('Bulk Deleted', res);
        }).catch((err) => this.onError('Failed to Delete Bulk', err));
    },

    // TANKS
    submitTank(tank, edit) {
      if (!edit) {
        this.createTank(tank);
      } else {
        this.editTank(tank);
      }
    },
    createTank(tank) {
      const newTank = {
        siteId: this.activeSiteId,
        ...tank,
      };
      this.$store.dispatch('tanksStore/createTank', newTank)
        .then((res) => {
          this.onSuccess('Tank Created', res);
          this.$refs.tankAdmin.resetForm();
        }).catch((err) => this.onError('Failed to Create Tank', err));
    },
    editTank(editedTank) {
      const tankUpdate = {
        ...editedTank,
      };

      this.$store.dispatch('tanksStore/updateTank', tankUpdate)
        .then((res) => {
          this.onSuccess('Tank Updated', res);
          this.$refs.tankAdmin.closeFormDialog();
        }).catch((err) => this.onError('Failed to Update Tank', err));
    },
    deleteTank(id) {
      this.$store.dispatch('tanksStore/deleteTank', id)
        .then((res) => {
          this.onSuccess('Tank Deleted', res);
        }).catch((err) => this.onError('Failed to Delete Tank', err));
    },

    // CLIENTS
    submitClient(client, edit) {
      if (!edit) {
        this.createClient(client);
      } else {
        this.editClient(client);
      }
    },
    createClient(client) {
      const newClient = {
        siteId: this.activeSiteId,
        ...client,
      };
      this.$store.dispatch('clientsStore/createClient', newClient)
        .then((res) => {
          this.onSuccess('Client Created', res);
          this.$refs.clientsAdmin.resetForm();
        }).catch((err) => this.onError('Failed to Create Client', err));
    },
    editClient(editedClient) {
      const clientUpdate = {
        ...editedClient,
      };

      this.$store.dispatch('clientsStore/updateClient', clientUpdate)
        .then((res) => {
          this.onSuccess('Tank Updated', res);
          this.$refs.clientsAdmin.closeFormDialog();
        }).catch((err) => this.onError('Failed to Update Client', err));
    },
    deleteClient(id) {
      this.$store.dispatch('clientsStore/deleteClient', id)
        .then((res) => {
          this.onSuccess('Client Deleted', res);
        }).catch((err) => this.onError('Failed to Delete Client', err));
    },

    // TOASTS
    onSuccess(message) {
      this.$toast.success(message);
    },
    onError(title, err) {
      this.$toast.error(`${title} - ${err.message ?? err}`);
      console.error(err.message);
    },
  },
};
